import { render, staticRenderFns } from "./visitlist.vue?vue&type=template&id=059b58c6&scoped=true&"
import script from "./visitlist.vue?vue&type=script&lang=js&"
export * from "./visitlist.vue?vue&type=script&lang=js&"
import style0 from "./visitlist.vue?vue&type=style&index=0&id=059b58c6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059b58c6",
  null
  
)

export default component.exports